import { PresetsActionTypes } from "./actionTypes";

export const PresetsActionCreators = {
    getSubsidiaries: () => ({
        type: PresetsActionTypes.GET_SUBSIDIARIES
    }),

    getPresets: ({ page, top, search, subsidiaries, types, prizeType, status, certified }) => ({
        type: PresetsActionTypes.GET_PRESETS,
        payload: {
            page,
            top,
            search,
            subsidiaries,
            types,
            prizeType,
            status,
            certified
        }
    }),

    updateEditingPreset: preset => ({
        type: PresetsActionTypes.UPDATE_PRESET,
        payload: {
            preset
        }
    }),

    addPreset: ({ game_specific_settings, prizes, base, notes }) => ({
        type: PresetsActionTypes.ADD_PRESET,
        payload: {
            game_specific_settings,
            prizes,
            base,
            notes
        }
    }),

    editPreset: ({ game_specific_settings, prizes, base, notes, presetId }) => ({
        type: PresetsActionTypes.EDIT_PRESET,
        payload: {
            game_specific_settings,
            prizes,
            base,
            notes,
            presetId
        }
    }),

    clearPreset: () => ({
        type: PresetsActionTypes.CLEAR_PRESET
    }),

    clearSubmitPreset: () => ({
        type: PresetsActionTypes.CLEAR_SUBMIT_PRESET
    }),

    getPreset: presetID => ({
        type: PresetsActionTypes.GET_PRESET,
        payload: {
            presetID
        }
    }),

    activatePreset: presetId => ({
        type: PresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        payload: {
            active: true,
            presetId: presetId
        }
    }),

    deactivatePreset: presetId => ({
        type: PresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        payload: {
            active: false,
            presetId: presetId
        }
    }),

    certifiedPreset: (presetId, certified) => ({
        type: PresetsActionTypes.TOGGLE_CERTIFIED_PRESET,
        payload: {
            certified: certified,
            presetId: presetId
        }
    }),

    getDenominations: () => ({
        type: PresetsActionTypes.GET_DENOMINATIONS
    }),

    getGameBundles: () => ({
        type: PresetsActionTypes.GET_BUNDLES
    }),

    getGames: () => ({
        type: PresetsActionTypes.GET_GAMES
    })
};
